import styled from 'styled-components';

export const OurHistory = styled.section`
  background: #f2f2f2;
  margin: 0 auto;
  position: relative;
  padding-top: 100px;
  padding-bottom: 100px;
  overflow: hidden;
  @media (max-width: 992px) {
    padding-top: 50px;
    padding-bottom: 50px;
  }
  @media (max-width: 575.98px) {
    padding: 50px 15px;
  }
`;
export const OurHistoryContainer = styled.div`
  max-width: 1706px;
  margin: 0 auto;
  position: relative;
`;
export const OurHistoryCaption = styled.div`
  max-width: 1305px;
  text-align: center;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 1800px) {
    padding-left: 15px;
    padding-right: 15px;
  }
  h2 {
    color: #000;
    font-size: 30px;
    line-height: 30px;
    font-weight: 400;
    text-transform: capitalize;
    @media (max-width: 1199px) {
      font-size: 26px;
      line-height: 30px;
    }
    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 30px;
    }
  }

  p {
    color: #898989;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 50px;
    max-width: 822px;
    text-align: center;
    margin-top: 50px;
    @media (max-width: 1300px) {
      margin-bottom: 35px;
      margin-top: 30px;
    }
    &[dir='ltr'] {
      @media (max-width: 992px) {
        text-align: center;
      }
    }
    @media (max-width: 992px) {
      margin-bottom: 25px;
      margin-top: 16px;
    }
  }
`;
export const OurHistoryContent = styled.div`
  max-width: 1305px;
  text-align: center;
  margin: 0 auto;
  position: relative;
  @media (max-width: 1800px) {
    padding-left: 15px;
    padding-right: 15px;
  }
  .swiper {
    .swiper-slide {
      span {
        width: 100%;
      }
      img {
        width: 100%;
        height: 641px;
        object-fit: cover;
        @media (max-width: 1600px) {
          height: 550px;
        }
        @media (max-width: 560px) {
          height: 250px;
        }
      }
      p {
        font-size: 14px;
        line-height: 20px;
        padding-top: 40px;
        text-align: center;
        color: #4a4a4a;
        margin-bottom: 0px;
        @media (max-width: 1300px) {
          padding-top: 15px;
        }
      }
    }
  }
  &[dir='ltr'] {
    .swiper {
      .swiper-slide {
        p {
          letter-spacing: 1.29px;
        }
      }
    }
  }
`;
export const HistoryNavigationButton = styled.div`
  position: absolute;
  top: 50%;
  max-width: 1298px;
  width: 100%;
  left: 0px;
  display: flex;
  justify-content: space-between;
`;
export const OurHistoryPagination = styled.div`
  max-width: 1170px;
  position: relative;
  margin: 0px auto;
  padding-top: 43px;
  @media (max-width: 1200px) {
    max-width: 1100px;
    padding-left: 15px;
    padding-right: 15px;
  }
  @media (max-width: 992px) {
    max-width: 960px;
  }
  @media (max-width: 768px) {
    padding-top: 20px;
    max-width: 720px;
  }
  @media (max-width: 576px) {
    max-width: 540px;
  }
  &:before {
    position: absolute;
    content: '';
    width: 93%;
    height: 2px;
    background-color: #b4b4b4;
    display: block;
    top: 46px;
    left: 4%;
    @media (max-width: 768px) {
      top: 24px;
    }
  }
  .swiper {
    position: relative;
    padding-top: 10px;
    .swiper-slide {
      cursor: pointer;
      p {
        font-size: 25px;
        margin-bottom: 0px;
        font-weight: 400;
        line-height: 46px;
        @media (max-width: 992px) {
          font-size: 17px;
          line-height: 26px;
        }
      }
    }
    .swiper-slide:before {
      position: absolute;
      top: -10px;
      width: 8px;
      height: 8px;
      background: #b4b4b4;
      border-radius: 50%;
      content: '';
      display: block;
      left: 50%;
    }
    .swiper-slide-thumb-active {
      &:before {
        background: #3b79d6;
      }
      button {
        p {
          color: #3b79d6;
        }
      }
    }
  }
`;
export const OurHistoryPaginatinButton = styled.button`
  outline: none;
  border: none;
  width: 100%;
  cursor: pointer;
  font-family: DINRegular;
  background: transparent;
  margin-top: -10px;
  p {
    color: #b4b4b4;
  }
`;
export const PrevButton = styled.button`
  outline: none;
  border: none;
  background-color: #f2f2f2;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 22%;
  left: -90px;
  cursor: pointer;
  z-index: 10;
  svg {
    width: 13px;
  }
  @media (max-width: 1910px) {
    left: -60px;
  }
  @media (max-width: 1500px) {
    left: -10px;
    width: 35px;
    height: 35px;
    background-color: #f2f2f2;
    svg {
      width: 10px;
    }
  }
  @media (max-width: 1300px) {
    left: 0px;
  }
  @media (max-width: 992px) {
    background-color: #e2dfdf;
    width: 35px;
    height: 35px;
    top: 12%;
    left: -10px;
    svg {
      width: 10px;
    }
  }
`;
export const NextButton = styled.button`
  outline: none;
  border: none;
  background-color: #f2f2f2;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 22%;
  right: -100px;
  cursor: pointer;
  z-index: 10;
  svg {
    width: 13px;
  }
  @media (max-width: 1910px) {
    right: -60px;
  }
  @media (max-width: 1500px) {
    right: -10px;
    width: 35px;
    height: 35px;
    background-color: #f2f2f2;
    svg {
      width: 10px;
    }
  }
  @media (max-width: 1300px) {
    right: 0px;
  }
  @media (max-width: 992px) {
    background-color: #e2dfdf;
    width: 35px;
    height: 35px;
    top: 12%;
    right: -10px;
    svg {
      width: 10px;
    }
  }
`;
export const OurStoryPagination = styled.div`
  margin-top: 40px;
  @media (max-width: 992px) {
    margin-top: 30px;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  &[dir='rtl'] {
    ul {
      li {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }
  ul {
    display: flex;
    padding: 0px;
    margin: 0px;
    li {
      list-style: none;
      width: 30px;
      height: 30px;
      color: #b3b3b3;
      font-size: 12px;
      font-weight: 700;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      &.selected {
        background-color: #3b79d6;
        color: #fff;
        a {
          color: #fff !important;
        }
      }
      a {
        color: #b3b3b3;
        display: flex;
        width: 30px;
        height: 30px;
        justify-content: center;
        align-items: center;
        svg {
          width: 12px;
          height: 12px;
          path {
            fill: #000;
          }
        }
      }
    }
  }
`;
